import C from 'actionTypes'

const setIsInitialLoad = value => ({
  type: C.SET_IS_INITIAL_LOAD,
  value
})

const setLoadingPortfolio = value => ({
  type: C.SET_PORTFOLIO_IS_LOADING,
  value
})

const setLoadingPortfolioClassAllocations = value => ({
  type: C.SET_PORTFOLIO_CLASS_ALLOCATIONS_ARE_LOADING,
  value
})

const setLoadingPortfolioAccounts = value => ({
  type: C.SET_PORTFOLIO_ACCOUNTS_ARE_LOADING,
  value
})

const setLoadingPortfolioHoldings = value => ({
  type: C.SET_PORTFOLIO_HOLDINGS_ARE_LOADING,
  value
})

const setLoadingDocuments = value => ({
  type: C.SET_DOCUMENTS_ARE_LOADING,
  value
})

export default {
  setIsInitialLoad,
  setLoadingPortfolio,
  setLoadingPortfolioClassAllocations,
  setLoadingPortfolioAccounts,
  setLoadingPortfolioHoldings,
  setLoadingDocuments,
}



// WEBPACK FOOTER //
// ./src/actions/client/loading.js